import { isDefinedAndNotNull } from "../utils/dom";

export class ValidationService {
    
    isRequiredField(field) {
        return isDefinedAndNotNull(field.required) && field.required === "1";
    }
    
    validateRegularExpressions(customerInfoField, formValue, resourcesService) {
        //Regex based Validation
        let isValid = true;
        let validationMessage = '';
    
        if (customerInfoField.validation != undefined && formValue != "") {
            let validationKeys = customerInfoField.validation;
            validationKeys.forEach(validationKey => {
                let regExpression = resourcesService.getResource(validationKey.toUpperCase() + "_VALIDATION_RULE", '');
                regExpression = regExpression.replace(/&quot;/g, '"');
                if (regExpression != '' && !(new RegExp(regExpression)).test(formValue)) {
                    validationMessage = resourcesService.getResource(validationKey.toUpperCase() + "_VALIDATION_ERROR", '');
                    isValid = false;
                }
            });
        }
        return [isValid, validationMessage];
    }
    
    validateRequiredField(formData) {
        if (formData.type === 'checkbox' & !formData.checked) {
            const parentElement = formData.parentElement;
            const checkMarkList = (isDefinedAndNotNull(parentElement)) ? parentElement.getElementsByClassName('v24-scheduler-checkmark') : null;
            if (checkMarkList.length > 0) {
                checkMarkList[0].classList.add("v24-scheduler-checkmark-error");
            }
            formData.focus();
            return false;
        } else if (formData.type === 'email') {
            return formData.validity.valid;
        } else if (formData.type !== 'checkbox' & formData.value.trim() === '') {
            return false;
        }
        return true;
    }

}
